<template>
  <div class="wt2-sg">
    <wt-button
      type="primary"
      :icon="'wticon-plus2'"
      :text="title"
      @click="click"
    />
  </div>
</template>

<script>
import app from 'app';
import wtMakeNewWochit from 'components/modals/types/wtMakeNewWochit.component.vue';
import wtMakeNewStoryboard from 'components/modals/types/wtMakeNewStoryboard.component.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'MakeWochitButton',

  computed: {
    ...mapGetters('user', ['isImpededTemplatizer']),

    useTemplate() {
      return this.isImpededTemplatizer;
    },

    title() {
      return this.useTemplate
        ? app.culture.masthead.newStoryboard
        : app.culture.masthead.newStory;
    },

    aiTitle() {
      return app.culture.masthead.newAiStory;
    },
  },

  methods: {
    click() {
      app.analytics('masthead:makeNewWochit', { source: 'button' });

      app.showModal({
        type: this.useTemplate ? 'small' : 'custom scrollable',
        component: this.useTemplate ? wtMakeNewStoryboard : wtMakeNewWochit,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .wticon {
  font-size: 14px;
  font-weight: bold;
}
/deep/ .wticon.wticon-magic-wand {
  font-size: 14px;
  font-weight: normal;
}
</style>
